import { CommonModule } from "@angular/common";
import { Component, Input, ViewEncapsulation } from "@angular/core";
import { FlexModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule, MatMenuPanel } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { RolesEnum } from "../../../../../../../../../api/acl/account/models/enums/roles.enum";
import { Tickets } from "../../../../../../../../../api/acl/ticket/models/tickets.model";
import { DirectivesModule } from "../../../../../../../../../directives/directives.module";
import { LocalizedDatePipe } from "../../../../../../../../../pipes/localized-date.pipe";
import { ValueOrDashPipe } from "../../../../../../../../../pipes/value-or-dash.pipe";
import { isDefined } from "@datorama/akita";
import { EquipmentStatuses } from "../../../../../../../../../api/acl/equipments/models/enums/equipment-statuses.enum";

@Component({
    selector: "acl-batch-ticket-tile[ticket]",
    templateUrl: "./batch-ticket-tile.template.html",
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
    FlexModule,
    TranslateModule,
    LocalizedDatePipe,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    CommonModule,
    MatListModule,
    DirectivesModule,
    MatTooltipModule,
    ValueOrDashPipe
]
})
export class BatchTicketTileComponent {
    @Input()
    public ticket: Tickets;

    @Input()
    public actionMenu: MatMenuPanel;

    @Input()
    public actionMenuData: { ticket: Tickets };

    @Input()
    public selectable = false;

    @Input()
    public formattedBinNumber: string;

    @Input()
    public showQuantity: boolean;

    @Input()
    public showDensity: boolean;

    @Input()
    public showPoundsPerAcre: boolean;

    protected readonly RolesEnum = RolesEnum;

    public getEquipmentIdentifier(ticket: Tickets): string {
        if (isDefined(ticket.equipment)) {
            return ticket.equipment.identifier;
        }

        // This is not ideal since if a ticket was associated with an equipment, but then disassociated, the equipment identifier would still show up.
        if (isDefined(ticket.newEquipmentStatusHistories) && ticket.newEquipmentStatusHistories.length > 0) {
            // Sorting by createdAt in descending order. Spreading the array to avoid mutating the original array with sort.
            const withClientEquipmentStatusHistory = [...ticket.newEquipmentStatusHistories]
                .sort((left, right) => new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime())
                .find(
                    history => history.newStatus === EquipmentStatuses.Reserved
                );
            
            if (isDefined(withClientEquipmentStatusHistory)) {
                return withClientEquipmentStatusHistory?.equipment?.identifier;
            }
        }
    }
}
